import { connect } from 'react-redux';

// Component
import DashBoardNew from './DashBoardNew';
// Actions
import {
  getDashboadInvoice,
  getDashboardAttendance,
  getDashboardCustomerPerformance,
  getDashboardEstimation,
  getDashboardJobInfoToday,
  getDashboardJobInfoCustom,
  getDashboardOrganizationSales,
  getDashboardPerformers,
  getDashboardProjectCount,
  getDashboardRevenue,
  getDashboardTimesheetCount,
} from './dashBoardNewActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  profileData: state.profile.profileData,

  jobsInfoTodayIsloading: state.dashboard.jobsInfoTodayIsloading,
  jobsInfoToday: state.dashboard.jobsInfoToday,
  jobsCustomIsloading: state.dashboard.jobsInfoCustomIsloading,
  jobsCustom: state.dashboard.jobsInfoCustom,
  attendanceIsLoading: state.dashboard.attendanceIsLoading,
  attendanceData: state.dashboard.attendanceData,
  revenueIsLoading: state.dashboard.revenueIsLoading,
  lastYearRevenue: state.dashboard.lastYearRevenue,
  thisYearRevenue: state.dashboard.thisYearRevenue,
  currentMonthIndex: state.dashboard.currentMonthIndex,
  performersIsLoading: state.dashboard.performersIsLoading,
  topPerformers: state.dashboard.topPerformers,
  invoiceIsLoading: state.dashboard.invoiceIsLoading,
  invoiceData: state.dashboard.invoiceData,
  estimationIsLoading: state.dashboard.estimationIsLoading,
  estimationData: state.dashboard.estimationData,
  topCustomersIsLoading: state.dashboard.customerPerformanceIsLoading,
  topCustomers: state.dashboard.customerPerformanceData,
  organizationSalesIsLoading: state.dashboard.organizationSalesIsLoading,
  orgSales: state.dashboard.organizationSalesData,
  projectCountIsLoading: state.dashboard.projectCountIsLoading,
  projectCountData: state.dashboard.projectCountData,
  timesheetCountIsLoading: state.dashboard.timesheetCountIsLoading,
  timesheetCountData: state.dashboard.timesheetCountData,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getJobInfoToday: details => dispatch(getDashboardJobInfoToday({ ...details })),
  getJobInfoCustom: details => dispatch(getDashboardJobInfoCustom({ ...details })),
  getDashboardAttendance: details => dispatch(getDashboardAttendance({ ...details })),
  getDashboardInvoice: details => dispatch(getDashboadInvoice({ ...details })),
  getDashboardPerformers: details => dispatch(getDashboardPerformers({ ...details })),
  getDashboardRevenue: details => dispatch(getDashboardRevenue({ ...details })),
  getDashboardTopCustomers: details => dispatch(getDashboardCustomerPerformance({ ...details })),
  getDashboardEstimation: details => dispatch(getDashboardEstimation({ ...details })),
  getDashboardOrganizationSales: details => dispatch(getDashboardOrganizationSales({ ...details })),
  getDashboardProjectCount: details => dispatch(getDashboardProjectCount({ ...details })),
  getDashboardTimesheetCount: details => dispatch(getDashboardTimesheetCount({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(DashBoardNew);